import { EmailConfirmedScreen } from "@/features/auth/screens/EmailConfirmedScreen";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/email-confirmed")({
    component: EmailConfirmedScreen,
});
